import React from 'react';
import '../components/header.css';
import './home.css';
import Sec11 from '../components/sec11';
import Footer from '../components/footer';
import Sec12 from '../components/sec12';



const Contact = () => {
  return (<>
    
      <div className="home-page">
        <Sec11 />
        <Sec12 />
        <Footer />
      </div>
      </>);
};

export default Contact;